import { html, View, on } from 'rune-ts';
import klass from './Lists.module.scss';
import { ButtonAction } from '../../../../shared/components/atoms/ButtonAction/ButtonAction';
import { classes } from '../../../../shared/util';
import type { PopupStoreItemCardType, PopupStorePagination } from '../../../../features/PopupStores/type';
import { groupBy } from '@fxts/core';
import { format } from 'date-fns';
import { ClockFillIcon } from '../../../components/atoms/Icon';
import { typoPcMo } from '../../../../shared/typography/typo';
import { PopupStoreItemCard } from '../../../components/cells/PopupStore/PopupStoreItemCard';
import { getArchivedPopupStores } from '../../../../features/PopupStores/api';

interface ArchivedListProps {
  items: PopupStoreItemCardType[];
  pagination: PopupStorePagination;
  is_mobile: boolean;
}

export class ArchivedList extends View<ArchivedListProps> {
  state: {
    page: number;
    is_more: boolean;
  } = {
    page: 1,
    is_more: true,
  };

  constructor(props: ArchivedListProps) {
    super(props);
    this.state.page = props.pagination.page;
  }

  makeGroupHtml(key, items) {
    const [year, month] = key.split('__');
    const { is_mobile } = this.data;
    return html`
      <div class="${klass.group}">
        <div class="${klass.group_token} ${typoPcMo({ is_mobile, pc: '16_medium', mo: '14_bold' })}">
          ${ClockFillIcon} ${ET('mps2::popup_store::archived::group_label', { year, month })}
        </div>
        <div class="${klass.list}">
          ${items.map((item) => new PopupStoreItemCard({ item, is_mobile, use_in: 'popup_store' }))}
        </div>
      </div>
    `;
  }

  groupItemsByMonth(items: typeof this.data.items) {
    return groupBy((item) => {
      return format(new Date(item.start_at), 'yyyy__MM');
    }, items);
  }

  override template() {
    const { items } = this.data;
    const { is_more } = this.state;
    const group_by_month = this.groupItemsByMonth(items);

    return html`
      <div class="${klass.archived_list_container} ${classes({ [klass.is_more]: is_more })}">
        <div class="${klass.group_container}">
          ${Object.keys(group_by_month).map((key) => {
            return this.makeGroupHtml(key, group_by_month[key]);
          })}
        </div>
        <div class="${klass.see_more}">
          ${new ButtonAction({
            label: html`<span class="${klass.btn_text}">${ET('mps2::creator::see_more')}</span>`,
            size: 'large',
            fit: true,
            klass: klass.see_more_btn,
          })}
        </div>
      </div>
    `;
  }

  @on('click', `.${klass.see_more_btn}`)
  async onClickMoreBtn() {
    try {
      const { popup_stores } = await getArchivedPopupStores({ page: this.state.page + 1 });
      const [last_one] = popup_stores.slice(-1) || [];

      this.data.items.push(...popup_stores);
      this.state.page += 1;

      if (last_one) {
        // 팝업스토어 최초 게시일이 2021년 3월 이후이기 때문에, 2021년 3월 이후여야만 is_more 활성화
        this.state.is_more = last_one?.start_at > '2021-03';
      }
      this.redraw();
    } catch (err) {
      console.log(err);
    }
  }
}
